import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

export interface ScanDateRange {
  dateFrom: string | null;
  dateTo: string | null;
  datePreset: string | null;
}

function defaultDateRange(): ScanDateRange {
  const to = new Date();
  const from = new Date();
  from.setDate(to.getDate() - 6);
  const fmt = (d: Date): string => {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  };
  return { dateFrom: fmt(from), dateTo: fmt(to), datePreset: "Last 7 Days" };
}

@Injectable({
  providedIn: "root",
})
export class ScanFilterStateService {
  /** The root instance, for plain helpers that can't use DI (Angular 8 has
   *  no inject()) - see applyHeaderDateRange(). */
  static current: ScanFilterStateService | null = null;

  constructor() {
    ScanFilterStateService.current = this;
  }

  product: string | null = null;
  productId: number | null = null;
  status: string | null = null;

  private readonly dateRangeSubject = new BehaviorSubject<ScanDateRange>(
    defaultDateRange(),
  );

  readonly dateRange$: Observable<ScanDateRange> =
    this.dateRangeSubject.asObservable();

  get dateRangeSnapshot(): ScanDateRange {
    return this.dateRangeSubject.value;
  }

  get datePreset(): string | null {
    return this.dateRangeSubject.value.datePreset;
  }

  setDateRange(
    dateFrom: string | null,
    dateTo: string | null,
    datePreset: string | null,
  ): void {
    this.dateRangeSubject.next({ dateFrom, dateTo, datePreset });
  }

  /** Back to the app-wide default window (Last 7 Days). */
  resetDateRange(): void {
    this.dateRangeSubject.next(defaultDateRange());
  }

  reset(): void {
    this.product = null;
    this.productId = null;
    this.status = null;
    this.dateRangeSubject.next(defaultDateRange());
  }
}
